<div #bodyContent class="p-booking-info-mdl">
  <!-- [1.1] 代表者連絡先情報ブロック -->
  <asw-representative-information
    #representativeInformationComponent
    *ngIf="representativeInformationParts?.isDisplay"
    [id]="'passenger-information-input-modal-representative-information'"
    [(data)]="representativeInformationData"
    [parts]="representativeInformationParts"
    [(isOpen)]="isOpenRepresentativeInformation"
    (dataChange)="onDataChange(editArea.REPRESENTATIVE_CONTACT)"
    (phoneTypeEvent)="onChangePhoneTypeRepresentative($event)"
    (phoneNumberEvent)="onChangePhoneNumberRepresentative($event)"
  ></asw-representative-information>
  <!-- [1.3] 搭乗者情報ブロック -->
  <ng-container *ngFor="let passengerInformation of listOfPassengerInfoDataGroup; index as i">
    <asw-passenger-information
      #passengerInformationComponent
      *ngIf="passengerInformation?.parts?.isDisplay"
      [id]="'passenger-information-' + i"
      [passengerIndex]="i"
      [addressDuringStayOfFirstPassenger]="addressDuringStayOfFirstPassenger"
      [secondContentOfFirstPassenger]="secondContentOfFirstPassenger"
      [isSecondContentRegistAfterReservationOfFirstPassenger]="isSecondContentRegistAfterReservationOfFirstPassenger"
      [(data)]="passengerInformation.data"
      [parts]="passengerInformation.parts"
      [(isOpen)]="passengerInformation.parts.isOpen"
      (isOpenChange)="onChangeStatePassengerComponent($event, i)"
      (dataChange)="onDataChange(editArea.TRAVELER_INPUT, i)"
      [representativeData]="representativeInformationData"
      [isDisplayRepresentative]="representativeInformationParts.isDisplay"
      [isDisplayReflectBtn]="isDisplayReflectBtn()"
    ></asw-passenger-information>
  </ng-container>
</div>
